<h2 mat-dialog-title>Подтверждение</h2>

<mat-dialog-content>
  Вы уверены?
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Отменить</button>
  <button mat-raised-button color="primary" (click)="confirm()">Подтвердить</button>
</mat-dialog-actions>
